import React, { useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { Link } from 'react-router-dom';
import CategoriesItems from '../../data/reshto.json';
import { motion } from 'framer-motion';

// img
import boxShape from '../../images/top-shape.svg';
import spoon from '../../images/spoon.svg';
import SectionTitle from '../ui/SectionTitle';


export default function Categories() {
    const [CategoriesItemsData] = useState(CategoriesItems);
    
    return (
        <>
            <motion.section className='section' initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}}>
                <Container>
                    <Row className='justify-content-center'>
                        <Col md={6} className='section-title text-center mb-5'>
                                <SectionTitle title="Popular Categories"/>
                        </Col>
                        <Col md={12}>
                                <Swiper
                                    spaceBetween={24}
                                    navigation={{
                                        nextEl: '.swiper-button-next',
                                        prevEl: '.swiper-button-prev',
                                    }}
                                    modules={[Autoplay, Navigation]}
                                    autoplay={{
                                        delay: 2500,
                                    }}
                                    breakpoints={{
                                        0: {
                                            slidesPerView: 1,
                                        },
                                        576: {
                                            slidesPerView: 2,
                                        },
                                        992: {
                                            slidesPerView: 3,
                                        },
                                        1200: {
                                            slidesPerView: 4,
                                        },
                                    }}
                                    className="category-slider"
                                >
                                    {CategoriesItemsData.CategoriesData.map((data, i) =>
                                        <SwiperSlide key={i}>
                                            <motion.div className='category-item' initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}} custom={i}>
                                                        <Image src={require(`../../images/dish-img/${data.foodImg}`)} alt="" className='img-fluid food-dish-img' />
                                                <Image src={boxShape} alt="" className='w-100 img-fluid' />
                                                <motion.div className='category-item-box'>
                                                    <motion.h5 className='category-item-title mb-1 fw-semibold' initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.5 }}>{data.recipesName}</motion.h5>
                                                    <motion.p className='category-item-subtitle text-muted' initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.5 }}>{data.recipesSubTitle}</motion.p>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <motion.div whileHover="hover" whileTap="tap">
                                                            <Link to="/" className='text-danger fs-20 fw-semibold mb-0'>Order Now <i className="ri-arrow-right-fill"></i></Link>
                                                        </motion.div>
                                                        <motion.h5 className='text-danger fs-20 fw-bold mb-0' initial={{ scale: 0.8 }} whileInView={{ scale: 1 }} transition={{ duration: 0.5 }}>{data.recipesPrice}</motion.h5>
                                                    </div>
                                                </motion.div>
                                                <motion.div whileHover="hover">
                                                    <Image src={spoon} alt="" className='category-spoon-img' />
                                                </motion.div>
                                            </motion.div>
                                        </SwiperSlide>
                                    )}
                                    <motion.div className='category-slider-navigation' initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.5 }}>
                                        <motion.div className="swiper-button-next" whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }}>
                                            <i className="ri-arrow-right-fill"></i>
                                        </motion.div>
                                        <motion.div className="swiper-button-prev" whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }}>
                                            <i className="ri-arrow-left-fill"></i>
                                        </motion.div>
                                    </motion.div>
                                </Swiper>
                        </Col>
                    </Row>
                </Container>
            </motion.section>
        </>
    )
}
